// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete'
import Vuetify from 'vuetify'
import VCurrencyField from 'v-currency-field'
import VueCookies from 'vue-cookies'

Vue.use(Vuetify)

Vue.use(VueCookies)
Vue.$cookies.config('7d')

Vue.use(VuetifyGoogleAutocomplete, {
  apiKey: 'AIzaSyCSABPIVCChDfRCjPc-ghpZfyq1YY5g7-s'
})

Vue.use(VCurrencyField, {
  decimalLength: 0,
  autoDecimalMode: true,
  min: null,
  max: null,
  defaultValue: 0,
  prefix: '$',
  valueAsInteger: true
})

Vue.filter('toCurrency', function (value) {
  if (typeof value !== 'number') {
    return value
  }
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0
  })
  return formatter.format(value)
})

Vue.filter('toNumber', function (value) {
  if (typeof value !== 'number') {
    return value
  }
  var formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0
  })
  return formatter.format(value)
})

Vue.config.productionTip = false

let vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#004952'
      }
    }
  }
})

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js